import React from 'react';
import { Box, Text, Progress, Flex } from '@chakra-ui/react';
import { getCssVariable } from '../Utils/utils';

const ProgressComponent = ({
  current,
  total,
  title,
  variant = 'sm',
  showCount = true,
  showTitle = true,
}) => {
  const progressValue = (Number(current) / Number(total)) * 100;
  const size = getCssVariable(`--${variant}-size`) || 'sm';
  const colorScheme = getCssVariable(`--${variant}-color-scheme`) || 'SutterSyncPurple';

  return (
    <Box mb={4}>
      {/* Accessible Progress Bar */}
      <Progress
        value={progressValue}
        size={size}
        colorScheme={colorScheme}
        role="progressbar"
        aria-valuenow={progressValue}
        aria-valuemin={1}
        aria-valuemax={total}
        aria-labelledby={`${title ? `${title} progress` : 'Progress'} is ${Math.round(progressValue)}%`}
        aria-label={`${title ? `${title} progress` : 'Progress'} is ${Math.round(progressValue)}%`}
        style={{
          borderRadius: `var(--${variant}-border-radius, 8px)`,
          backgroundColor: `var(--${variant}-background-color, var(--color-dusky-teal-50)`,
          height:'4px',
        }}
        sx={{
          "&[style*='width']": {
            background: "linear-gradient(to right, red, yellow)",
          },
        }}
      />

      {/* Title and Current/Total */}
      <Flex
        style={{
          marginTop: `var(--${variant}-margin-top, 8px)`,
          marginBottom: `var(--${variant}-margin-bottom, 16px)`,
          justifyContent: `var(--${variant}-justify-content, space-between)`,
          alignItems: `var(--${variant}-align-item, center)`,
        }}
      >
        {/* Title */}
        {showTitle && (
          <Text
            fontSize={`var(--${variant}-title-font-size, 14px)`}
            fontWeight={`var(--${variant}-title-font-weight, 400)`}
            color={`var(--${variant}-title-color, black)`}
            textTransform={`var(--${variant}-text-transform, uppercase)`}
          >
            {title}
          </Text>
        )}

        {/* Current / Total Count */}
        {showCount && (
          <Text
            fontSize={`var(--${variant}-count-font-size, 14px)`}
            fontWeight={`var(--${variant}-count-font-weight, 400)`}
            color={`var(--${variant}-count-color, gray)`}
          >
            {current && total ? `${current} of ${total}` : current || total}
          </Text>
        )}
      </Flex>
    </Box>
  );
};

export default ProgressComponent;
